"use client";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import { getAllSubscriptions } from "../../../services/subscriptionService";
import { SubscribersList } from "../../../components/admin/subscribers/SubscribersList";
import ExportButtons from "../../../components/admin/common/ExportButtons";

const Subscribers = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["subscriptions"],
    queryFn: getAllSubscriptions,
  });

  useEffect(() => {
    if (data) {
      setSubscriptions(data.data);
    }
  }, [data]);

  if (isLoading) return <div className="text-center p-4">Loading...</div>;

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      <div className="h-full">
        <div className="sticky top-0 h-screen text-white">
          <Sidebar />
        </div>
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <Header
                title="Subscribers"
                desc="Browse, filter, and manage all news articles in your publication"
              />
              <div className="mb-4">
                <ExportButtons model="subscriptions" />
              </div>

              <SubscribersList subscriptions={subscriptions} />
              <div className="h-8" />
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default Subscribers;
